export function getGenderLabel(genderId: number): string {
    const genderLabels: { [key: number]: string } = {
        1: 'Male',
        2: 'Female',
        3: 'Others'
    };

    return genderLabels[genderId] || 'Unknown'; 
}